import { ApplicationFeature, ActionPlanRiskConsequence, ActionPlanRiskLikelihood,assertNever, errorCodes, incidentTypeTextDa } from './amorg-common'
import { ArticleChangeImportance } from './amorg-common/DTOs/articles/ArticleHelperTypes';
import { IncidentPriority, IncidentStatus, IncidentType } from './amorg-common/DTOs/Incident';

const riskAssessment = {
    consequence:(consequence:ActionPlanRiskConsequence):string => {
        if(consequence === '1 - small') return 'Lille konsekvens';
        else if(consequence === '2 - significant') return 'Betydelig konsekvens';
        else if(consequence === '3 - severe') return 'Alvorlig konsekvens';
        else if(consequence === '4 - catastrophic') return 'Katastrofal konsekvens';
        else return '';
    },
    likelihood:(likelihood:ActionPlanRiskLikelihood):string => {
        if(likelihood === '1 - unlikely') return 'Usandsynligt';
        else if(likelihood === '2 - rare') return 'Sjældent';
        else if(likelihood === '3 - possible') return 'Muligt';
        else if(likelihood === '4 - likely') return 'Sandsynligt';
        else return '';
    }
}

export const txt = {

    fieldValidation: {
        mandatoryText: (maxLength:number, currentText?:string) =>
            currentText !== undefined 
                ? `Skal udfyldes. Må maks indeholde ${maxLength} (${currentText.length}) tegn.`
                : `Skal udfylde. Må maks indeholde ${maxLength} tegn.`,

        optionalText: (maxLength:number, currentText?:string) =>
            currentText !== undefined 
                ? `Må maks indeholde ${maxLength} (${currentText.length}) tegn.`
                : `Må maks indeholde ${maxLength} tegn.`,
    },

    getDynamic: (key: string) => {

        for (const propName in txt) {
            if (key == propName)
                return txt[propName];
        }
        return `[missing text: ${key}]`
    },

    getErrorCode: (error: errorCodes) => {
        const errorTxt = erroCodeTxt.find(e => e.error === error);
        if (errorTxt === undefined) {
            console.log(`missing translation for errorCode:${error}`);
            return `[${error}]`;
        }
        return errorTxt.txt;
    },
    articleChangeImportanceText,
    riskAssessment,
    problemType,
    riskLikelihood,
    riskProblemTypeConsequence,
    incidentTypeText,
    incidentPriorityText,
    incidentStatusText,
    featureText,

    MembersMustHaveTraining_title: 'Et medlem manger lovpligtig uddannelse',
    MembersMustHaveTraining: 'Alle medlemmer skal noget med en længere tekst som Mikkel skal forfatte.... Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',

    MainCommitteeMustHaveEmployerRep_title: 'Et primært udvalg skal have en arbejdsgiverrepræsentant',
    MainCommitteeMustHaveEmployerRep: 'Lang tekst skal indsættes her om krav',

    ActivityType_AnnualWorkgroupStatus: 'Årlig drøftelse',
    ActivityType_AnnualWorkgroupStatus_Description: 'Her kan du oprette jeres årlige arbejdsmiljødrøftelse. Arbejdsmiljøorganisationen skal drøfte arbejdsmiljøarbejdet, mindst én gang om året. Dette skal foregå til den årlige arbejdsmiljødrøftelse. Arbejdsmiljødrøftelsen er en vigtig del af virksomhedens arbejdsmiljøarbejde, hvor formålet er at tilrettelægge samarbejdet om arbejdsmiljøarbejdet bedst muligt. Aktiviteten giver dig mulighed for at registrer en agenda, noter fra mødet og hvem der har deltaget.',
    ActivityType_WorkgroupMeeting: 'AMO møde',
    ActivityType_WorkgroupMeeting_Description: 'Her har du mulighed for at oprette mødeaktiviteter for arbejdsmiljøorganisationen, arbejdsmiljøudvalget eller arbejdsmiljøgruppen. Ved oprettelse af et møde kan du definere en agenda, skrive egne mødereferater samt tilføje deltagere til mødet. Kort sagt kan i få et godt overblik over jeres aktiviteter og planer.',
    ActivityType_WorkplaceAssessment: 'APV',
    ActivityType_WorkplaceAssessment_Description: 'Opret din virksomheds arbejdspladvurdering her. APV’en er virksomhedens redskab til at holde styr på arbejdsmiljøet. APV’en skal laves minimum hvert 3. år eller ved væsentlige ændringer med betydning for arbejdsmiljøet. APVen giver dig mulighed for at oprette et spørgeskema samt handleplaner.',
    ActivityType_Presentation: 'Præsentation',
    ActivityType_Presentation_Description: 'Semiotics bicycle rights direct trade lumbersexual craft beer four loko hoodie helvetica echo park bitters readymade hashtag migas ennui tofu. Narwhal cliche kombucha marfa, small batch shabby chic helvetica occupy hot chicken woke bitters kickstarter. Mlkshk adaptogen vice ennui health goth edison bulb poke leggings marfa ethical. Irony ennui echo park authentic, vice twee chillwave.',
    ActivityType_Lecture: 'Undervisning',
    ActivityType_Lecture_Description: 'Semiotics bicycle rights direct trade lumbersexual craft beer four loko hoodie helvetica echo park bitters readymade hashtag migas ennui tofu. Narwhal cliche kombucha marfa, small batch shabby chic helvetica occupy hot chicken woke bitters kickstarter. Mlkshk adaptogen vice ennui health goth edison bulb poke leggings marfa ethical. Irony ennui echo park authentic, vice twee chillwave.',
    ActivityType_Training: 'Træning',
    ActivityType_Training_Description: 'Semiotics bicycle rights direct trade lumbersexual craft beer four loko hoodie helvetica echo park bitters readymade hashtag migas ennui tofu. Narwhal cliche kombucha marfa, small batch shabby chic helvetica occupy hot chicken woke bitters kickstarter. Mlkshk adaptogen vice ennui health goth edison bulb poke leggings marfa ethical. Irony ennui echo park authentic, vice twee chillwave.',
    ActivityType_SafetyInspection: 'Sikkerhedsrundering',
    ActivityType_SafetyInspection_Description: 'Sikkerhedsrunderingen giver dig mulighed for at registrere hvornår og af hvem dette er udført, samt angive detaljer om lokation.',
    ActivityType_Treatment: 'Behandling',
    ActivityType_Treatment_Description: 'Semiotics bicycle rights direct trade lumbersexual craft beer four loko hoodie helvetica echo park bitters readymade hashtag migas ennui tofu. Narwhal cliche kombucha marfa, small batch shabby chic helvetica occupy hot chicken woke bitters kickstarter. Mlkshk adaptogen vice ennui health goth edison bulb poke leggings marfa ethical. Irony ennui echo park authentic, vice twee chillwave.',
    ActivityType_CustomForm: 'Undersøgelse',
    ActivityType_CustomForm_Description: 'Undersøgelser giver dig mulighed for at oprette formularer og indsamle data fra dine medarbejdere og eksterne eksperter.',

    NewActivityType_AnnualWorkgroupStatus: 'Ny årlig drøftelse',
    NewActivityType_WorkgroupMeeting: 'Nyt AMO møde',
    NewActivityType_WorkplaceAssessment: 'Ny APV',
    NewActivityType_Presentation: 'Ny præsentation',
    NewActivityType_Lecture: 'Ny undervisning',
    NewActivityType_Training: 'Ny træning',
    NewActivityType_SafetyInspection: 'Ny sikkerhedsrundering',
    NewActivityType_Treatment: 'Ny behandling',

    PermissionGroupId_anonymous: 'Anonym',
    PermissionGroupId_user: 'Bruger',
    PermissionGroupId_member: 'AMO medlem',
    PermissionGroupId_consultant: 'Arbejdsmiljørådgiver',
    PermissionGroupId_siteadmin: 'Administrator',
    PermissionGroupId_superadmin: 'AMORG administrator',

    SurveyTopicIdentifier_LinkType_theme: 'Tema',
    SurveyTopicIdentifier_LinkType_indicator: 'Indikator',
    SurveyTopicIdentifier_LinkType_question: 'Spørgsmål',

    InspectionPointStatus_pending: 'Ikke kontrolleret',
    InspectionPointStatus_passed: 'Godkendt', 
    InspectionPointStatus_conditionallyPassed: 'Betinget godkendt',
    InspectionPointStatus_failed: 'Ikke godkendt',

    ArticleImportance_none_text: 'Ændringerne er ikke vurderet',
    ArticleImportance_low_text: 'Ændringerne vurderes til ikke at have betydning',
    ArticleImportance_medium_text: 'Ændringerne vurderes til at have betydning og anbefales at blive evalueret',
    ArticleImportance_high_text: 'Ændringerne vurderes til at have betydning og bør evalueres',    

    ArticleEvaluation_none_text: 'Ingen evaluering foretaget',
    ArticleEvaluation_low_text: 'Lovkravet overholdes',
    ArticleEvaluation_medium_text: 'Lovkravet overholdes delvist',
    ArticleEvaluation_high_text: 'Lovkravet overholdes ikke',  

    InternalArticleEvaluation_none_text: 'Ingen evaluering foretaget',
    InternalArticleEvaluation_low_text: 'Forpligtelsen overholdes',
    InternalArticleEvaluation_medium_text: 'Forpligtelsen overholdes delvist',
    InternalArticleEvaluation_high_text: 'Forpligtelsen overholdes ikke',

    IncidentType_issue: 'Hændelse',
    IncidentType_almost_accident: 'Nær-ved-ulykke',
    IncidentType_whistleblower: 'Whistleblower',
    IncidentType_work_injury: 'Arbejdsskade'

};

function featureText(feature:ApplicationFeature):string
{
    if(feature === 'Organization')
        return 'Organisation';
    else if(feature === 'Locations')
        return 'Lokationer';
    else if(feature === 'Meeting')
        return 'Møder';
    else if(feature === 'AnnualStatus')
        return 'Årlig drøftelse';
    else if(feature === 'WorkplaceAssessment')
        return 'APV';
    else if(feature === 'SafetyInspection')
        return 'Sikkerhedsrundering';
    else if(feature === 'CustomForms')
        return 'Ergotjek';
    else if(feature === 'Articles')
        return 'Lovservice';
    else if(feature === 'ArticlesLight')
        return 'Lovservice light (Vidensdatabasen)';
    else if(feature === 'Learning')
        return 'Opslagsværket';
    else if(feature === 'ActionPlans')
        return 'Handleplaner';
    else if(feature === 'ExternalLinks')
        return 'Eksterne links';
    else if(feature === 'DocumentArchive')
        return 'Dokumentarkiv';
    else if(feature === 'Incidents')
        return 'Indberetninger (under udvikling)';
    else if(feature === 'Notifications')
        return 'Notifikationer';
    else if(feature === 'ArticleLandingPage')
        return 'Lovservice startside';
    else if(feature === 'EmployeePortal')
        return 'Medarbejderportal';
    else if(feature === 'PublicArticles')
        return 'Offentlig visning af lovkrav';
    else
        assertNever(feature);
}

function incidentTypeText(type:IncidentType):string
{
    return incidentTypeTextDa(type);
}

function incidentPriorityText(priority:IncidentPriority):string
{
    if(priority === '0 - unassigned')
        return 'Ikke tildelt';
    else if(priority === '1 - low')
        return 'Lav';
    else if(priority === '2 - normal')
        return 'Normal';
    else if(priority === '3 - high')
        return 'Høj';
    else if(priority === '4 - urgent')
        return 'Kritisk';
    else
        assertNever(priority);
}

function incidentStatusText(status:IncidentStatus):string
{
    if(status === 'new')
        return 'Ny indberetning';
    else if(status === 'in-progress')
        return 'Under behandling';
    else if(status === 'resolved')
        return 'Afsluttet';
    else
        assertNever(status);
}

export type ArticleImportanceVariant = 'change' | 'evaluation' | 'internal-evaluation';
function articleChangeImportanceText(mode:ArticleImportanceVariant, importance?:ArticleChangeImportance):string
{
    if(mode === 'change')
    {
        if(!importance) return txt.ArticleImportance_none_text;
        else if(importance === 'low') return txt.ArticleImportance_low_text;
        else if(importance === 'medium') return txt.ArticleImportance_medium_text;
        else if(importance === 'high') return txt.ArticleImportance_high_text;
    }
    else if(mode === 'evaluation')
    {
        if(!importance) return txt.ArticleEvaluation_none_text;
        else if(importance === 'low') return txt.ArticleEvaluation_low_text;
        else if(importance === 'medium') return txt.ArticleEvaluation_medium_text;
        else if(importance === 'high') return txt.ArticleEvaluation_high_text;
    }
    else if(mode === 'internal-evaluation')
    {
        if(!importance) return txt.InternalArticleEvaluation_none_text;
        else if(importance === 'low') return txt.InternalArticleEvaluation_low_text;
        else if(importance === 'medium') return txt.InternalArticleEvaluation_medium_text;
        else if(importance === 'high') return txt.InternalArticleEvaluation_high_text;
    }
}

export const ProblemTypes = ['absence' , 'accidents' , 'ergonomics' , 'indoor-climate' , 'psychological-work-environment' , 'chemicals' , 'ATEX' , 'biological-agents' , 'radiation'] as const;
export type ProblemType = typeof ProblemTypes[number];
function problemType(problemType:ProblemType):string
{
    const mapping:Record<ProblemType, string> = {
        'absence': 'Fravær',
        'accidents': 'Ulykker',
        'ergonomics': 'Ergonomi',
        'indoor-climate': 'Indeklima',
        'psychological-work-environment': 'Psykisk arbejdsmiljø',
        'chemicals': 'Kemi',
        'ATEX': 'ATEX',
        'biological-agents': 'Biologiske agenser',
        'radiation': 'Stråling'
    };
    return mapping[problemType];
}

function riskLikelihood(likelihood:ActionPlanRiskLikelihood):string
{
    const mapping:Record<ActionPlanRiskLikelihood, string> = {
        '1 - unlikely': 'Hændelsen/skaden sker nok aldrig',
        '2 - rare': 'Hændelsen/skaden sker måske på et tidspunkt',
        '3 - possible': 'Hændelsen/skaden vil nok ske med tiden',
        '4 - likely': 'Hændelsen/skaden vil ske',
    };
    return mapping[likelihood];
    
}

function riskProblemTypeConsequence(problemType:ProblemType, consequence:ActionPlanRiskConsequence):string
{
    const mapping:Partial<Record<ProblemType, Record<ActionPlanRiskConsequence, string>>> = {
        'absence': {
            '1 - small': 'Ingen mén og typisk ikke fravær',
            '2 - significant': 'Skaden heler eller giver begrænsede mén, der er fravær - typisk under en måned',
            '3 - severe': 'Skaden giver væsentlige mén og der er fravær - typisk over en måned',
            '4 - catastrophic': 'Livsforkortende eller invaliderende mén og risiko for permanent uarbejdsdygtighed'
        },
        'accidents': {
            '1 - small': 'Hudafskrabninger, blå mærker, mindre sår og skrammer, klemte fingre',
            '2 - significant': 'Mindre brud (fingre/tæer), forstuvninger, snitsår, forbrænding (1. og 2. gr.)',
            '3 - severe': 'Større knoglebrud, beskadiget syn, amputationer (fingre/tæer), alvorlige ætsninger og forbrændinger (3. gr.)',
            '4 - catastrophic': 'Død, forgiftning, amputationer (større), svært invaliderende'
        },
        'ergonomics': {
            '1 - small': 'Ømhed og muskelspændinger',
            '2 - significant': 'Fibersprængninger, ikke permanente smerter i bevægapparatet',
            '3 - severe': 'Permanente skader og smerter i bevægapparatet - fx nedslidningsskader',
            '4 - catastrophic': 'Invaliderende skader'
        },
        'indoor-climate': {
            '1 - small': 'Ikke permanente Indeklimasymptoner, mindre hud-, øjen- og luftvejsirritationer',
            '2 - significant': 'Permanente indeklimasymptomer,  hud-, øjen- og luftvejsirritationer',
            '3 - severe': 'Permanente indeklimasymptoner,  hud-, øjen- og luftvejsirritationer',
            '4 - catastrophic': 'Invaliderende skader'
        },
        'psychological-work-environment': {
            '1 - small': 'Som sædvanligt eller oplevelse af lettere øget arbejdspres eller -belastning',
            '2 - significant': 'Øget korttidssygefravær, sammenstød mellem kollegaer, begyndende fald i produktivitet',
            '3 - severe': 'Langtidsygemeldinger pga. stress/konflikter, alvorlige personkonflikter, tilfælde af mobning/chikane/krænkende adfærd, trusler',
            '4 - catastrophic': 'Opsigelser, fyringer, sygemeldinger med risiko for permanent skade. Hyppige mobningstilfælde, ødelæggende personkonflikter'
        },
        'chemicals': {
            '1 - small': 'Lettere luftvejs-, øjen- og hudirritation, tør hud og lignende',
            '2 - significant': 'Forgiftninger - ubehag, Forbrændinger (1 og 2. grads) og lignende. Luftvejs-, øjen- og hudirritation',
            '3 - severe': 'Forgiftninger - sygdom, beskadiget syn, ætsninger og kraftige forbrændinger (3.grads), Allergifremkaldende -, Neurotoksisk stoffer. Reproduktionsskadende (misdannelse på foster, nedsat evne til at blive gravid etc.)',
            '4 - catastrophic': 'Død, forgiftninger - livstruende, kræftfremkaldende, Reproduktionsskadende (spontan abort)',
        },
        'ATEX': {
            '1 - small': 'Meget svag eksplosion og minimal følgevirkning',
            '2 - significant': 'Svag til moderat eksplosion og følgevirkning',
            '3 - severe': 'Moderat til stor eksplosion og følgevirkning',
            '4 - catastrophic': 'Stor eksplosion og følgevirkning'
        },
        'biological-agents': {
            '1 - small': 'Belastninger der kan give anledning til ubehag - fx ildelugt. (Risikogruppe 1 organismer)',
            '2 - significant': 'Influenzasymptomer, diarre, uspecifik men forbigående sygdom. (Risikogruppe 2 organismer)',
            '3 - severe': 'Udsættelse der kan medføre alvorlige akutte symptomer, længerevarende sygdom, svækkelse af immunforsvar. (Risikogruppe 3 og visse risikogruppe 2 organismer)',
            '4 - catastrophic': 'Udsættelse der enten på kort eller lang sigt vil kunne forsage døden eller alvorlige irreversible følger. (Risikogruppe 4 og visse risikogruppe 3 organismer)',
        },
        'radiation': {
            '1 - small': 'Radiosendere i normalt brugsudstyr',
            '2 - significant': 'HF-svejsere til plast.  Arbejde i nærheden af højspændingstransformatorer',
            '3 - severe': 'Mikrobølgestråler og direkte radarstråler. Betastråling',
            '4 - catastrophic': 'Stødfare fra strømførende HF-dele. Gamma/røntgen stråling. Alfastråling på gasform (Radon)'
        }
    };
    return mapping[problemType]?.[consequence] ?? '';
}

const erroCodeTxt: { error: errorCodes, txt: string }[] = [
    { error: 'invalid_site', txt: 'Der opstod en uventet fejl. Kontakt amorg support.' },

    { error: 'confirmUserCreation_invalid_requestId', txt: 'Linket er ikke gyldigt.' },
    { error: 'confirmUserCreation_invalid_userId', txt: 'Linket er ikke gyldigt.' },
    { error: 'confirmUserCreation_no_requests_exist', txt: 'Linket er ikke gyldigt. Dette kan bl.a. skyldes at der er gået for lang tid siden du forsøgte at oprette brugeren, eller at brugeren allerede er aktiveret.' },
    { error: 'confirmUserCreation_userId_in_use', txt: 'Linket er ikke længere gyldigt. Du kan oprette en ny bruger fra login panelet' },
    { error: 'confirmUserCreation_email_in_use', txt: 'En bruger er allerede oprettet med den indtastede e-mail' },
    { error: 'uploadReferenceFile_public_file_name_in_use', txt: 'En fil med det valgte navn findes allerede' }
];